export class VerticalsEnvironment {
  public static getName = () => 'benzinga-verticals';
  public static getEnvironment = () => ({
    verticals: new URL('https://www.benzinga.com/api/sheets/verticals/list'),
  });
}
